import { MediaLocationTypes } from '../dto/itemPropTypes';
export const getSourceForExternalCloudIngestedItem = (sourceKey: string, externalBucketName: string, storageId?: string) => ({
  ingestSourceFullPath: sourceKey,
  ingestSourceS3Bucket: externalBucketName,
  ingestSourceStorageId: storageId,
  sourceFileLocation: MediaLocationTypes.ORIGIN
});
